import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useRemoteStartTransactionFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/ocpp/remote-start-transaction.form-validation';
import { RemoteStartTransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/ocpp/remote-start-transaction.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ChargePointChannelTransactionStartFormStep1InformationFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } =
      useFormContext<
        Pick<
          RemoteStartTransactionModel,
          'chargePointId' | 'channelId' | 'tokenIdentifier'
        >
      >();
    const { tokenIdentifier } = useRemoteStartTransactionFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Card flex={1}>
        <Stack direction="column" gap={GapEnum.L}>
          <AccentTitle
            as={HeadingEnum.H2}
            icon="info-circle"
            text={t(
              '$.charge-point-channel-transaction-start.step-1.information.title',
            )}
            variant={AccentVariantEnum.Primary}
          />
          <Controller
            name="tokenIdentifier"
            control={control}
            rules={tokenIdentifier}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextInput
                  label={t(
                    'delmonicos-shared-sdk.inputs-ocpp-remote-start-transaction.token-identifier',
                  )}
                  placeholder={t(
                    'delmonicos-shared-sdk.inputs-ocpp-remote-start-transaction.token-identifier',
                  )}
                  required={!!tokenIdentifier.required}
                  errorMessage={error?.message}
                  {...field}
                  value={field.value ?? ''}
                  onChange={(e) => {
                    field.onChange(e.target.value === '' ? '' : e.target.value);
                  }}
                />
              );
            }}
          />
        </Stack>
      </Card>
    );
  };

export const ChargePointChannelTransactionStartFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.XL}>
        <Stack
          direction="column"
          flex={1}
          alignItems="stretch"
          gap={GapEnum.XL}>
          <ChargePointChannelTransactionStartFormStep1InformationFragment />
        </Stack>
      </Stack>
    );
  };
